<template>
  <modal
    :is-visible="isVisible"
    :title="$t('c.contentCopyModal.title')"
    @close="close"
  >
    <form-wrap>
      <form-field-set :should-show-border="false">
        <grouped-select-input
          v-model="folderId"
          :label="$t('c.contentCopyModal.form.label.folder')"
          :options="groupedFoldersOptions"
          :required="true"
          name="folderId"
          direction="vertical"
          empty-label="..."
        />

      </form-field-set>

      <form-actions>
        <button-input
          :is-disabled="isInvalid"
          @click="submit"
        >
          <font-awesome-icon
            icon="arrow-alt-circle-right"
          />
          <span v-t="'c.contentCopyModal.form.action.submit'"/>
        </button-input>
        <a
          v-t="'c.contentCopyModal.form.action.cancel'"
          class="cancel"
          @click="close()"
        />
      </form-actions>
    </form-wrap>
  </modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import FormMixin from '@/mixins/forms/Form'
import Modal from '@/components/ui/Modal'
import isBlank from 'is-blank'

export default {
  name: 'ContentCopyModal',
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon,
    Modal
  },
  data () {
    return {
      folderId: ''
    }
  },
  computed: {
    ...mapState({
      isVisible: state => state.contentCopyModal.isVisible,
      contentId: state => state.contentCopyModal.id,
    }),
    ...mapGetters({
      groupedFoldersOptions: 'groupedFoldersOptions',
    }),
    isInvalid () {
      return isBlank(this.folderId)
    }
  },
  methods: {
    ...mapActions({
      show: 'openContentCopyModal',
      close: 'closeContentCopyModal',
      fetchWritableFolders: 'fetchWritableFolders',
      copyContentToFolder: 'contents/copyToFolder',
    }),
    submit () {
      const contentId = this.contentId
      const folderId = this.folderId
      this.copyContentToFolder({contentId, folderId})
        .then(({data}) => {
          this.close()
        })
    }
  },

  created () {
    this.fetchWritableFolders()
  },

  destroyed () {
    this.folderId = ''
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contents/ContentCopyModal.vue